import { Dialog, DialogContent, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { cn } from '@/lib/utils';
import clsx from 'clsx';
import { useState } from 'react';
import './size.css';

export function FindYourSize({ className, sizeChartInfo }: { className?: string; sizeChartInfo: any }) {
  const [isOpen, setIsOpen] = useState(false);

  const { content: productSizeContent } = sizeChartInfo || {};
  const { title: productSizeTitle } = sizeChartInfo || {};

  return (
    <Dialog
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <DialogTrigger asChild>
        <button
          type='button'
          className={cn('font-roboto-medium text-base font-medium leading-none underline', className)}
        >
          View Size Chart
        </button>
      </DialogTrigger>
      <DialogContent
        className={clsx('w-full max-w-[840px] p-0', 'bg-white', 'z-[1700] h-full max-h-full overflow-auto lg_h-auto')}
        overlayClassName='z-[1600]'
        showCloseButton={false}
        aria-describedby={undefined}
      >
        <DialogTitle className='hidden'>size chart</DialogTitle>
        <div className={clsx('  pb-5 lg_h-[617px]', 'relative', 'h-full', 'flex flex-col overflow-hidden')}>
          <div className='border-e0e0e0 flex min-h-[51px] flex-none items-center justify-between border-b-1 border-solid px-2.5 lg_min-h-[60px] lg_px-[35px]'>
            <h2 className='font-teko-medium text-2xl font-medium uppercase lg_text-[30px]'>{productSizeTitle}</h2>
            <button
              type='button'
              onClick={() => {
                setIsOpen(false);
              }}
              className='lg_flex lg_h-[46px] lg_w-[46px] lg_items-center lg_justify-center'
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='15'
                height='16'
                fill='none'
                viewBox='0 0 15 16'
              >
                <path
                  fill='#000'
                  d='M13.454 15.354 7.5 9.401l-5.954 5.953a.497.497 0 0 1-.7 0l-.701-.7a.497.497 0 0 1 0-.7L6.1 8 .145 2.046a.497.497 0 0 1 0-.7l.7-.701a.497.497 0 0 1 .701 0L7.5 6.599 13.454.645a.497.497 0 0 1 .7 0l.702.7a.496.496 0 0 1 0 .701L8.9 8l5.954 5.954a.496.496 0 0 1 0 .7l-.701.701a.494.494 0 0 1-.7 0'
                ></path>
              </svg>
            </button>
          </div>
          <div className={clsx(' mt-5 flex-1 overflow-hidden px-3 lg_mt-[17px] lg_px-[35px]')}>
            <div className={clsx('max-h-full overflow-auto ')}>
              <div
                className='product-size-chart'
                dangerouslySetInnerHTML={{
                  __html: productSizeContent,
                }}
              />
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
